import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import CircularProgress from '@mui/material/CircularProgress';
import { NO_DATA_FOUND_LABEL } from '../../../constants';
import { STATUS_ROW_KEY } from '../constants';

type TableStatusRowProps = {
  colSpan: number;
  loading?: boolean;
  hasFetched?: boolean;
};

export const TableStatusRow = ({
  colSpan,
  loading = false,
  hasFetched = true,
}: TableStatusRowProps) => (
  <TableRow>
    <TableCell key={STATUS_ROW_KEY} colSpan={colSpan} align="center">
      {loading || !hasFetched ? (
        <CircularProgress size={24} />
      ) : (
        NO_DATA_FOUND_LABEL
      )}
    </TableCell>
  </TableRow>
);
